module.exports = __webpack_public_path__ + "static/world_map-187dcc9dfebcea049564509a0baa119f.png";